<template>
    <BasicDialog @close="closeClicked" :rounded="'rounded-16'"
      :width="'w-100 w-xxs-75 w-sm-50 w-md-33 w-lg-25 w-xl-17'">
  
      <div class="text-h6 font-weight-bold text-center">Please follow the instructions</div>
      <div class="my-4 text-body-2">
        <div v-for="(instruction, index) in formattedInstructions" :key="index">
          {{ instruction }}
        </div>
      </div>
      <div class="d-flex justify-center align-center">
        <v-btn rounded="pill" color="primary" @click="goToSupport">GO TO SUPPORT</v-btn>
      </div>
    </BasicDialog>
  </template>
  
  <script setup lang="ts">
  import { inject, computed, ref, provide } from 'vue';
  import { SupportInfo } from '@/interfaces/Offers/SupportInfo';
  import BasicDialog from '@/components/Common/Basic-Dialog.vue';
  
  const props = defineProps({
    support_info: Object as () => SupportInfo,
  });
  
  const emit = defineEmits(['close']);
  
  const supportDialogOpen = inject('supportDialogOpen');
  const openDialog = ref(supportDialogOpen);
  provide('openDialog', openDialog);
  
  const supportInfo = computed(() => props.support_info);
  
  const closeClicked = () => {
    emit('close');
    openDialog.value = false;
  };
  
  const goToSupport = async () => {
    if (supportInfo.value) {
      window.open(supportInfo.value.url, '_blank');
      closeClicked();
    }
  };
  
  const formattedInstructions = computed(() => {
    if (supportInfo?.value?.instructions.includes('1.')) {
      return supportInfo?.value.instructions.split(/(?=\d\. )/g);
    }
    return [supportInfo?.value?.instructions];
  });
  </script>
  
  <style></style>
  